import { useTellescopeMutation } from "@tellescope/tanstack-query";

/**
 * Hook for updating portal branding records.
 * Uses TanStack Query mutation with automatic cache invalidation.
 */
export function useUpdatePortalBranding() {
  return useTellescopeMutation({
    model: "portal_brandings",
    method: "updateOne",
    autoCacheUpdateStrategy: "invalidate",
  });
}
